import {
  callback as $callback,
  isBoolean,
  isFunction,
  isPlainObject,
  objectWithAccessors,
  withProperties
} from "../../utils";

const __TimeObjectProto__ = Object.freeze(
  withProperties(Object.create(null), {
    valueOf() { return this.time },
    toString() { return getTimeString(this.time) },
    countdownTick() {
      return this.time > 0 ? createTimeObject(--this.time) : this;
    }
  })
);

function elapsedSeconds(msDuration) {
  const PRECISION_SCALE = 128;
  const PRECISION_FACTOR = 1000 / PRECISION_SCALE;

  return (elapsedSeconds = function _seconds(msDuration) {
    return Math.ceil(msDuration / PRECISION_FACTOR) / PRECISION_SCALE;
  }).call(this, msDuration);
}

function parseTime(time) {
  return Math.max(0, +time || 0);
}

function createTimeObject(time) {
  const $timeObject = Object.create(__TimeObjectProto__);

  let __time__;

  return Object.freeze(objectWithAccessors.call($timeObject, {
    time: {
      getter() { return __time__ },
      setter(time) { __time__ = parseTime(time) }
    }
  }), $timeObject.time = time);
}

function getTimeString(value) {
  const remaining = Math.max(0, +value || 0);
  const minutes = Math.floor(remaining / 60);
  const seconds = remaining % 60;

  const timeString = [minutes, seconds]
    .map(piece => "00".concat(piece || 0).slice(-2))
    .join(":");

  return timeString;
}

function parseTimerOptions(options) {
  const { callback, duration, autostart = false } =
    isPlainObject(options) ? options : ({
      [
        isFunction(options) && "callback" ||
        isBoolean(options) && "autostart" ||
        "duration"
      ]: options
    });

  return withProperties(Object.create(null), {
    autostart: autostart === true,
    callback: $callback(callback),
    duration: parseTime(Math.ceil(parseFloat(duration)))
  });
}

export {
  createTimeObject,
  elapsedSeconds,
  getTimeString,
  parseTime,
  parseTimerOptions
}
